const styles = (theme) => ({
  link: {
    color: theme.palette.primary.dark,
    textDecoration: 'none',
  },
});

export default styles;
